import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ReportService } from 'src/app/services/report/report.service';

@Component({
  selector: 'app-report-filter-report005',
  templateUrl: './report-filter-report005.component.html',
  styleUrls: ['./report-filter-report005.component.scss']
})
export class ReportFilterReport005Component implements OnInit {

  filters: any = {};
  comboOptions: any;
  isLoadingComboOptions: boolean = false;

  constructor(
    private reportSerivce: ReportService
  ) {
  }

  ngOnInit(): void {
  }

  // Attribute: data

  @Output()
  dataChange = new EventEmitter<any>();

  @Input()
  get data() {
    return this.filters;
  }

  set data(value) {
    this.filters = value;
    this.dataChange.emit(this.filters);
  }

  // Attribute: options

  @Output()
  optionsChange = new EventEmitter<any>();

  @Input()
  get options() {
    return this.comboOptions;
  }

  set options(value: any) {
    this.comboOptions = value;
    this.optionsChange.emit(this.comboOptions);
  }

  // Attribute: loading

  @Output()
  loadingChange = new EventEmitter<boolean>();

  @Input()
  get loading() {
    return this.isLoadingComboOptions;
  }

  set loading(value) {
    this.isLoadingComboOptions = value;
    this.loadingChange.emit(this.isLoadingComboOptions);
  }


  prefixFilter($evt:any)
  {
    let filter = {}

    if(!!this.filters.distributionCenter){
      filter = {...filter, ...{'distribution-center':this.filters.distributionCenter}};
    }

    if(!!this.filters.classification){
      filter = {...filter, ...{'classification':this.filters.classification}};
    }
    this.reportSerivce.filter('place', filter).then((resp) =>{
      console.log(resp);
      this.comboOptions.place = resp;
    });
  }
}
